import {createReducer} from "redux-act";
import {RequestState} from "modules/enums";
import {IUserReducer} from "modules/types/reducers";
import {
	actionEnableGodMode,
	checkUserNameFailed,
	checkUserNameSuccess,
	retrieveUserSuccess,
	saveLoginPayloadStore,
	sendThanksForPlayingViewedSuccess,
	setSessionState,
} from "modules/actions";
import {
	ICheckUserNameResponse,
	IReducerAction,
	IUserLoginPayload,
	IUserResponse,
} from "modules/types";
import {MLBStorage} from "modules/utils/Storage";

const initialState: IUserReducer = {
	loadingState: RequestState.IDLE,
	sessionState: RequestState.IDLE,
	checkUserNameRequestState: RequestState.IDLE,
	currentUser: null,
	terms: false,
	userHasUserName: false,
	session: {
		uid: "",
		// token: "",
		platform: "web",
	},
	updates: undefined,
	isSecretEnabled: false,
	isGodMode: false,
};

type IUserReducerPayload<TP = null> = IReducerAction<IUserReducer, TP>;

const onSetSessionState: IUserReducerPayload<RequestState> = (state, payload) => ({
	...state,
	sessionState: payload,
});

const onRetrieveUserSuccess: IUserReducerPayload<IUserResponse> = (state, payload) => {
	if (payload.xSid) {
		MLBStorage.SET("xSid", payload.xSid);
	}

	return {
		...state,
		currentUser: payload.user,
		loadingState: RequestState.Received,
		terms: true,
	};
};

const onSaveLoginPayloadStore: IUserReducerPayload<IUserLoginPayload> = (state, payload) => ({
	...state,
	session: payload,
});

const onCheckUserNameSuccess: IUserReducerPayload<ICheckUserNameResponse> = (state, payload) => ({
	...state,
	checkUserNameRequestState: RequestState.Received,
	userHasUserName: payload.user.username,
});
const onCheckUserNameFailed: IUserReducerPayload = (state) => ({
	...state,
	checkUserNameRequestState: RequestState.Received,
});

const onSendThanksForPlayingViewedSuccess: IUserReducerPayload = (state) => ({
	...state,
	currentUser: {
		...state.currentUser!,
		isThanksForPlayingModalViewed: true,
	},
});
const onEnableGodMode: IUserReducerPayload = (state) => ({
	...state,
	isGodMode: true,
});

export const user = createReducer({}, initialState)
	.on(setSessionState, onSetSessionState)
	.on(retrieveUserSuccess, onRetrieveUserSuccess)
	.on(saveLoginPayloadStore, onSaveLoginPayloadStore)
	.on(checkUserNameSuccess, onCheckUserNameSuccess)
	.on(checkUserNameFailed, onCheckUserNameFailed)
	.on(sendThanksForPlayingViewedSuccess, onSendThanksForPlayingViewedSuccess)
	.on(actionEnableGodMode, onEnableGodMode);
